import React from 'react';
import { ChannelState } from 'src/interfaces/ChannelState';

export type IConfigContext = {
	privateKey: Uint8Array;
	baseUrl: string;

	notificationEnabled?: boolean;

	channelState?: ChannelState;
	setChannelState: (state: ChannelState) => void;

	survey?: boolean;
	setSurvey: (survey: boolean) => void;

	locale: string;
	setLocale: (locale: string) => void;

	isInputLocked?: boolean;
	setLockInput: (lock: boolean) => void;

	isRecordAudioEnabled: boolean;
	isRecordAudioApproved?: boolean;
	setIsRecordAudioApproved: (approve?: boolean) => void;
};

export const configContext = React.createContext<IConfigContext>(
	{} as IConfigContext,
);
